// extracted by mini-css-extract-plugin
export default {"formLayoutDefaults":"Form_formLayoutDefaults__w-4ui","formDefaults":"Form_formDefaults__wq9rd","formDefaultsDark":"Form_formDefaultsDark__WpFMy"};